import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { Label, Button, ActionButton } from 'fw/components';
import { SetupTab } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API'
import SystemAPI from 'fw/system/API';
import * as App from 'modules/app/App'
import { DatePicker } from 'fw/forms';
import { DocumentUpload, SiteReviewSiteInfoAssessmentTypeCombo, SiteReviewSiteInfoFormTypeCombo } from "areas/shared/controls";
import { CommentsGrid } from 'areas/shared/components';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppReviewToolbar from 'areas/admin/certification/shared/AppReviewToolbar';
import AdminStepToolbar from 'areas/admin/certification/shared/AdminStepToolbar';
import * as ReportManager from 'modules/reports/ReportManager';
import * as Formatting from 'fw/misc/Formatting';

class SiteInfo extends SetupTab {
    initialForm() {
        return {
            reviewComment: ''
        }
    }

    urls() {
        return {
            get: API.Admin.url('/siteReview/getSiteInfo'),
            save: API.Admin.url('/siteReview/saveSiteInfo')
        }
    }

    privileges() {
        return {
            add: App.hasPrivilege('AdminSiteReviewAccess'),
            edit: App.hasPrivilege('AdminSiteReviewAccess')
        }
    }

    getRequest(selectedId) {
        return {
            certificationKey: selectedId
        }
    }

    saveRequest() {
        var form = this.state.form;

        return {
            siteReviewSiteInfoId: form.entityId,
            certificationKey: this.props.selectedId,
            siteAssessmentDate: form.siteAssessmentDate,
            siteAssessmentStorageToken: form.siteAssessmentStorageToken,
            siteAssessmentFileName: form.siteAssessmentFileName,
            assessmentTypeId: form.assessmentTypeId,
            formTypeId: form.formTypeId,
            rowVersion: form.rowVersion,
            reviewComment: this.state.reviewComment,
            assessmentNotRequired: this.state.form.assessmentNotRequired
        }
    }

    isEnabled(data){
        return !data.isReviewFinished;
    }

    isValidated(data){
        return data.isSubmitted;
    }

    updatePostData = (form, dirty) => {
        this.setState({ form })

        if (dirty === true) this.dirt()
    }

    handleUploadChange = (file, controlName) => {
        let form = this.state.form;
        form[controlName + "StorageToken"] = file.storageToken;
        form[controlName + "FileName"] = file.fileName;

        this.updatePostData(form, true);
    };

    handleAdminStepToolbar = (formParam) => {
        let form = this.state.form;

        if (formParam && formParam.comments)
            form.comments = formParam.comments;

        this.updatePostData(form, false);

        this.handleSubmit();
    }

    handleAppReviewToolbar = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentsGrid = (comments) => {
        this.handleUpdateComments(comments);
    }

    handleCommentChange = (comment) => {
        this.dirt();
        this.setState({
            reviewComment: comment
        });
    }

    handleUpdateComments(comments) {
        let form = {
            ...this.state.form,
            comments
        };
        this.updatePostData(form, false);
    }

    downloadForm = (formCode) => {
        new SystemAPI().download({
            storageToken: this.state.form["form" + formCode + "StorageToken"],
            fileName: this.state.form["form" + formCode + "FileName"]
        });
    };

    handlePrint = () => {
        const rq = Object.assign({
            reportType: "SiteReviewSiteInfoReport",
            format: "PDF",
            parameters: {
                CertificationId: this.state.form.certificationId
            }
        });

        ReportManager.execute(rq);
    };

    afterSave = (entityId, data) => {
        this.addCommentFromSave(data.reviewComment);
        this.props.setupProps._siteReview.getAvailableTabs();
    }

    afterSaveTabSelect = (entityId, data) => {
        this.props.setupProps._siteReview.getAvailableTabs();
    }

    addCommentFromSave = (comment) =>{
        if (comment === null) 
            return;
           
        let comments = this.state.form.comments;
                
        comments.unshift({
            commentId: comment.commentId,
            reviewTypeDescription: comment.reviewTypeDescription,
            queueTypeDescription: comment.queueTypeDescription,
            content: comment.content,
            addedDate: comment.addedAt,
            addedBy: comment.addedBy,
            commentTypeCode: comment.commentTypeCode
        });

        let form = {
            ...this.state.form,
            comments
        };

        this.updatePostData(form, false);

        // Clean Add Comment textbox
        this._commentsGrid.cleanComment();
        this.setState({ reviewComment: '' });

    }

    renderAdminStepToolbar = () => {
        const disableCancel = !this.state.buttons.cancel;
        //Show cancel
        const showCancel = this.state.showButtons.cancel;
        //Show save 
        const showSave = this.state.showButtons.save && this.state.enabled;
        
        return (
            <AdminStepToolbar
                onSave={this.handleAdminStepToolbar}
                certificationKey={this.props.selectedId}
                reviewTypeCode={'SIN'}
                queueTypeCode={'STR'}
                reviewStatus={this.state.form.reviewStatus}
                comments={this.state.form.comments}
                showCancel={(showCancel && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                showSave={(showSave && this.state.privileges.edit) || (this.state.adding && this.state.privileges.add)}
                hideNavButtons={!this.state.form.original.formTypeId}
                onCancel={this.handleCancel}
                disableCancel={disableCancel}
                setupProps={this.props.setupProps}
                handleTabSelect={this.props.handleTabSelect}
            />)
    }

    renderButtons = () => {
        return (
            <React.Fragment>
                <hr />
                <Row>
                    <Col md={6}>
                    </Col>
                    <Col md={2}>
                        {this.state.form.showReview ?
                            <AppReviewToolbar
                                queueTypeCode={'STR'}
                                reviewTypeCode={'SIN'}
                                comments={this.state.form.comments}
                                onFlagSave={this.handleAppReviewToolbar}
                                certificationKey={this.props.selectedId} />
                            : null}
                    </Col>
                    <Col md={4}>
                        {this.renderAdminStepToolbar()}
                    </Col>
                </Row>
            </React.Fragment>
        );
    }

    blankFormType = () => {
        let form = this.state.form;

        if (this.state.form.formTypeId !== 1){ 
            form.siteAssessmentStorageToken = null;
            form.siteAssessmentFileName = null;
        }

        this.updatePostData(form, true);
    }

    renderForm() {
        var form = this.state.form;

        return (
            <React.Fragment>                
                <Row>
                    <Col md={12}>
                        <Row>
                            <Col md={12}>
                                <h3>
                                   {this.state.form.siteReviewTitle}
                                   {this.renderAdminStepToolbar()}
                                   <div className="pull-right"><ActionButton id="btnPrint" onClick={this.handlePrint} icon="print" bsSize="sm">Print</ActionButton></div>
                                </h3>
                                <hr />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={5}>
                                <FormGroup>
                                    <Label htmlFor='siteAssementDate'>
                                        Site Assessment Scheduled Date
                                    </Label>
                                    <DatePicker
                                        disabled
                                        className='dpThin'
                                        name='siteAssessmentScheduleDate'
                                        placeholder='Not Scheduled'
                                        showTime={false} />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor='siteAssementDate'>
                                        Site Assessment Start Date
                                    </Label>
                                    <DatePicker
                                        disabled={!this.state.enabled || this.state.form.assessmentNotRequired}
                                        className='dpThin'
                                        name='siteAssessmentDate'
                                        placeholder='Select Date'
                                        showTime={false} />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor='assessmentTypeId' required={!this.state.form.assessmentNotRequired}>
                                        Recommended Assessment Type
                                    </Label>
                                    <SiteReviewSiteInfoAssessmentTypeCombo 
                                        required
                                        disabled={this.state.form.assessmentNotRequired}
                                        name="assessmentTypeId" />
                                </FormGroup>
                                <FormGroup>
                                    <Label htmlFor='formTypeId' required={!this.state.form.assessmentNotRequired}>
                                        Form Type
                                    </Label>
                                    <SiteReviewSiteInfoFormTypeCombo 
                                        required
                                        disabled={this.state.form.assessmentNotRequired}
                                        onChange={this.blankFormType} 
                                        name="formTypeId" />
                                </FormGroup>
                                {this.state.form !== null && this.state.form.formTypeId === 1 ? (
                                    <React.Fragment>
                                        {this.state.form !== null && this.state.form.assessmentTypeId === 1 ? (
                                            <FormGroup>
                                                <Label>Site Assessment Form</Label>
                                                <br />
                                                <Button bsStyle='default' bsSize='small' onClick={() => this.downloadForm("1901")} style={{ marginTop: 5 }}>
                                                    <FontAwesomeIcon icon={faExclamationTriangle} size='lg' color="orange" />
                                                    &nbsp;&nbsp;Please download Site Assessment Form 1901 here
                                                </Button>
                                            </FormGroup>
                                        ):null}
                                        {this.state.form !== null && this.state.form.assessmentTypeId === 2 ? (
                                            <FormGroup>
                                                <Label>Site Assessment Form</Label>
                                                <br />
                                                <Button bsStyle='default' bsSize='small' onClick={() => this.downloadForm("1902")} style={{ marginTop: 5 }}>
                                                    <FontAwesomeIcon icon={faExclamationTriangle} size='lg' color="orange" />
                                                    &nbsp;&nbsp;Please download Site Assessment Form 1902 here
                                                </Button>
                                            </FormGroup>
                                        ):null}
                                        <FormGroup>
                                            <Label htmlFor='siteAssessment' required>
                                                Completed Assessment Form
                                            </Label>
                                            <DocumentUpload
                                                storageToken={form.siteAssessmentStorageToken}
                                                fileName={form.siteAssessmentFileName}
                                                onChange={(file) => this.handleUploadChange(file, "siteAssessment")}
                                                wrapFileNameLength={40}
                                            />
                                        </FormGroup>
                                    </React.Fragment>
                                ): null }
                            </Col>
                            <Col md={7}>
                                <Label>VOB Summary</Label>
                                <table className="table table-striped table-bordered">
                                    <tbody>
                                    <tr>
                                            <td>
                                                Type of business premises
                                            </td>
                                            <td>
                                                {this.state.form.businessPremisesName !== null ?
                                                    <b>{this.state.form.businessPremisesName}</b>
                                                :
                                                    <b>–</b>
                                                    }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Does your Company carry or hold any Tangible Equipment or Inventory at a location?
                                            </td>
                                            <td>
                                                {this.state.form.locationEquipment !== null ?
                                                    <b>{this.state.form.locationEquipment ? "Yes" : "No"}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Personal Home/Residence
                                            </td>
                                            <td>
                                                {this.state.form.personalLocation !== null && this.state.form.locationEquipment !== null && this.state.form.locationEquipment ?
                                                    <b>{this.state.form.personalLocation ? "Yes" : "No"}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Company location
                                            </td>
                                            <td>
                                                {this.state.form.businessLocation !== null && this.state.form.locationEquipment !== null && this.state.form.locationEquipment  ?
                                                    <b>{this.state.form.businessLocation ? "Yes" : "No"}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Other Warehouse or Storage Facility
                                            </td>
                                            <td>
                                                {this.state.form.warehouseLocation !== null && this.state.form.locationEquipment !== null && this.state.form.locationEquipment  ?
                                                    <b>{this.state.form.warehouseLocation ? "Yes" : "No"}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Other Garage or Maintenance Facility
                                            </td>
                                            <td>
                                                {this.state.form.garageLocation !== null && this.state.form.locationEquipment !== null && this.state.form.locationEquipment  ?
                                                    <b>{this.state.form.garageLocation ? "Yes" : "No"}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Mobile Storage Unit (Container, POD, Truck, etc.)
                                            </td>
                                            <td>
                                                {this.state.form.mobileStorageLocation !== null && this.state.form.locationEquipment !== null && this.state.form.locationEquipment  ?
                                                    <b>{this.state.form.mobileStorageLocation ? "Yes" : "No"}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {this.state.form.annualRevenue1Year !== null ?
                                                    <p style={{margin:'0px'}}>
                                                        {this.state.form.annualRevenue1Year === this.state.form.yearBusinessFormed ?
                                                            "Gross receipt to date "
                                                        :
                                                            "Annual Revenue "
                                                        }
                                                        ({this.state.form.annualRevenue1Year})
                                                    </p>
                                                    
                                                :
                                                    <p>Last Annual Revenue</p>
                                                }
                                            </td>
                                            <td>
                                                {this.state.form.annualRevenue1 !== null ?
                                                    <b>{Formatting.formatCurrency(this.state.form.annualRevenue1)}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        {this.state.form.annualRevenue2Year !== null ?
                                            <tr>
                                                <td>
                                                    Annual Revenue ({this.state.form.annualRevenue2Year})
                                                </td>
                                                <td>
                                                    {this.state.form.annualRevenue2 !== null ?
                                                        <b>{Formatting.formatCurrency(this.state.form.annualRevenue2)}</b>
                                                    :
                                                        <b>–</b>
                                                    }
                                                </td>
                                            </tr>
                                        :null}
                                        <tr>
                                            <td>
                                                Geographic Market
                                            </td>
                                            <td>
                                                {this.state.form.geographicMarketName !== null ?
                                                    <b>{this.state.form.geographicMarketName}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                Number of Full Time Employees
                                            </td>
                                            <td>
                                                {this.state.form.amountFullTimeEmployee !== null ?
                                                    <b>{this.state.form.amountFullTimeEmployee}</b>
                                                :
                                                    <b>–</b>
                                                }
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={12}>
                        <hr />
                    </Col>
                </Row>
                <Row>
                    <CommentsGrid
                        ref={(c) => { this._commentsGrid = c }}
                        comments={form.comments}
                        documents={form.reviewDocuments}
                        certificationKey={this.props.selectedId}
                        reviewTypeCode={"SIN"}
                        queueTypeCode={"STR"}
                        enableExport={true}
                        entityId={form.siteReviewSiteInfoId}
                        readonly={!this.state.privileges.edit || !this.state.enabled}
                        onSave={this.handleCommentsGrid}
                        onCommentChange={this.handleCommentChange}
                    />
                </Row>
            </React.Fragment>
        )
    }
}

export default SiteInfo;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/siteReview/siteReviewInfo/siteInfo/SiteInfo.js